import SimpleNamedModal from './SimpleNamedModal'

export default SimpleNamedModal
